import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ROUTE_PATH } from "@static/route-paths";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";
import MainContainer from "@pages/EverGreen/Components/Container";
import DropdownCard from "@pages/EverGreen/Components/DropdownCard";
import { EverGreenStyle } from "@utils/Style/everGreen";
import Input from "@components/_Revamp/Input";
import { Checkbox } from "@components/_Shared/Checkbox";
import { themeDefault } from "src/theme-revamp";
import Dropdown from "@pages/EverGreen/Components/Dropdown";
// import { Nationalities } from "@static/nationalities";
import Icon from "@components/_Revamp/Icon";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { OtherTax, updateTaxData } from "@redux/slices/EVER_GREEN/step3Slice";
import { useHistory } from "react-router-dom";
import { Tooltip } from "@pages/EverGreen/Components/Tooltip";
import CRSModal from "./CRSModal";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import ErrorModal from "@pages/EverGreen/Components/ErrorModal";
import { store } from "@redux/store";
import { EVER_GREEN_STEP_LIST } from "@static/content";
import { SCREEN_SIZE } from "@static/screen-size";
import { trackOnFormStartOrSuccess, trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

const cardStyle = css`
  align-items: unset;
  background-color: white;
  padding: 0px;
`;

const contentStyle = css`
  padding: 24px;
`;

const addIconStyle = css`
  margin-right: 16px;
  font-size: 36px;
  font-weight: 400;
  margin-top: 4px;
`;

const tinContentStyle = css`
  margin-top: 36px;
`;

const removeButtonStyle = css`
  color: ${EverGreenStyle.colors.primary};
  font-size: ${EverGreenStyle.title14};
  font-weight: 600;
  margin-top: 36px;
  display: flex;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;
  width: fit-content;
`;

const removeIconStyle = css`
  margin-right: 8px;
  margin-top: -4px;
`;

const FieldLable = styled.div`
  font-size: 14px;
`;

const marketingRadioStyle = css`
  padding: 16px 24px;
  background-color: ${EverGreenStyle.colors.grey[700]};
  margin-top: 16px;
  border-radius: 8px;
`;

const subTextStyle = css`
  font-weight: 400;
  font-size: ${EverGreenStyle.title12};
`;

const explanationStyle = css`
  margin-top: 12px;
`;

const tooltipSpan = css`
  margin-left: 4px;

  /* span {
    .top {
        left: 0px;
        right: 0px;
        top: inherit;
        bottom: 0;
    }
  } */
`;

const containerBLock = css`
  width: 100vw;
  display: block;
  overflow: scroll;
  max-height: 100vh;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  justify-content: center;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    .nextBtn {
      margin-bottom: 170px;
    }
  }
`;

const TextNormal = styled.div`
  color: #434343;
  margin: 0;
  letter-spacing: 0.04em;

  @media screen and (max-width: 588px) {
    line-spacing: 19.6px;
  }
`;

const LooksGoodStyle = styled.button<{ disabled: boolean }>`
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px 60px;
  font-weight: 600;
  width: 180px;
  height: 52px;
  background: ${EverGreenStyle.colors.primary};
  border-radius: 101px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.08em;
  transition: all 0.1s linear;
  color: #fff;
  cursor: ${(prop) => (prop.disabled ? "auto" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.25 : 1)};
  margin-top: 80px;
  @media screen and (max-width: 950px) {
    margin-bottom: 275px;
  }
`;

const SelectButton = styled.button<{ selected: boolean }>`
  &:first-child {
    margin-top: 16px;
  }
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px 60px;
  font-weight: 600;
  font-size: 12px;
  width: 100%;
  max-width: 279px;
  height: 52px;
  background: ${(props) =>
    props.selected
      ? EverGreenStyle.colors.grey[700]
      : EverGreenStyle.colors.primary};
  border-radius: 8px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.08em;
  transition: all 0.1s linear;
  color: ${(props) =>
    props.selected ? EverGreenStyle.colors.grey[1200] : "#fff"};
  &:hover {
    background: ${EverGreenStyle.colors.primary};
    color: #fff;
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: 50%;
    margin-top: 16px;
    max-width: unset;
  }
`;

const AddAnotherStyle = styled.button<{ disabled: boolean }>`
  border: none;
  background-color: transparent;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-weight: 600;
  width: 100%;
  max-width: 327px;
  height: 73px;
  align-items: center;
  text-align: center;
  transition: all 0.1s linear;
  color: ${EverGreenStyle.colors.primary};
  cursor: ${(prop) => (prop.disabled ? "auto" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.25 : 1)};
  margin-top: 24px;
  font-size: 14px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23${EverGreenStyle.colors.primary.replace(
    "#",
    ""
  )}' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='11' stroke-linecap='square'/%3e%3c/svg%3e");

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 18px;
    padding: 0px 64px;
    max-width: unset;
  }
`;

const title14 = css`
  p {
    font-size: 14px;
  }
`;

const TitleSm = styled.div`
  font-size: ${EverGreenStyle.title14};
  font-weight: 500;
  line-height: 140%;
  color: ${EverGreenStyle.colors.grey[500]};
  display: flex;
`;

const TextArea = styled.textarea`
  box-sizing: border-box;
  resize: none;
  padding: 16px;
  border-radius: 8px;
  border: 1px ${EverGreenStyle.colors.grey[1000]} solid;
  height: 142px;
  width: 100%;
  box-shadow: none;
  outline: none;
  margin-top: 16px;
  color: ${EverGreenStyle.colors.primary};
  font-weight: 600;
`;

const lengthTextStyle = css`
  text-align: right;
  margin-top: 8px;
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  line-height: 16.8px;
  letter-spacing: 0.015em;
  color: #c9c9c9;
`;

interface TaxContentProps {
  data?: {
    country?: string;
    haveTin: boolean;
    tinNumber?: string;
    reason?: string;
  };
  selectedList: Array<{ id: string; label: string }>;
  onRemove?: () => void;
  selectedCountry?: string[];
  onUpdate: (fieldName: string, value: unknown) => void;
  onError: (error: string) => void;
}

const initialTaxData = {
  countryOfTaxResidence: "",
  hasOtherTaxNumber: null,
  taxIdentificationNumber: "",
  reasonForNoTaxIdentificationNumber: "",
  reasonExplanation: "",
  countryOfTax: "",
};

const excludeCountry = ["US"];

function TaxContent(props: TaxContentProps) {
  const [haveTin, setHaveTin] = useState<boolean>();
  const [selected, setSelected] = useState<string>();
  const [tin, setTin] = useState<string>();
  const [country, setCountry] = useState<string>(props.data?.country || "");
  const [explanation, setExplanation] = useState<string>("");
  const countryList = useAvivaSelector(
    (state) => state.everGreenStep1.staticData.countryList
  );
  const defaultTax = useAvivaSelector(
    (state) => state.everGreenStep2.myInfo.nric
  );

  const validateForm = useCallback(() => {
    if (haveTin) {
      if ((!tin?.match(/^[STFG]\d{7}[A-JZ]$/) && country === "SG") || !tin) {
        props.onError("invalidTin");
        return;
      }
    } else {
      if (!selected) {
        props.onError("invalidReason");
        return;
      } else {
        if (selected.includes("notObtain") && !explanation) {
          props.onError("invalidExplanation");
          return;
        }
      }
    }
    if (!country) {
      props.onError("invalidCountry");
      return;
    }
    props.onError("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country, explanation, haveTin, selected, tin]);

  useEffect(() => {
    validateForm();
  }, [validateForm]);

  useEffect(() => {
    if (
      tin === undefined &&
      (props.data?.tinNumber || defaultTax) &&
      props.data?.haveTin === true
    ) {
      if (country === "SG") {
        setTin(props.data?.tinNumber || defaultTax);
        props.onUpdate(
          "singaporeTaxNumber",
          props.data?.tinNumber || defaultTax
        );
      } else {
        setTin(props.data?.tinNumber || "");
      }
    }
  }, [country, defaultTax, props, tin]);

  useEffect(() => {
    if (
      (tin !== undefined || props.data?.haveTin !== undefined) &&
      haveTin === undefined
    ) {
      if (country === "SG") {
        setHaveTin(
          props.data?.haveTin === undefined ? true : props.data.haveTin
        );
        props.onUpdate(
          "hasSingaporeTaxNumber",
          props.data?.haveTin ? "Y" : "N"
        );
      } else {
        setHaveTin(
          props.data?.haveTin === undefined ? false : props.data.haveTin
        );
      }
    }
  }, [country, haveTin, props, tin]);

  useEffect(() => {
    if (haveTin === false && selected === undefined) {
      setSelected(
        props.data?.reason === undefined ? "notIssue" : props.data?.reason
      );
      props.onUpdate(
        "reasonForNoTaxIdentificationNumber",
        props.data?.reason === undefined ? "notIssue" : props.data?.reason
      );
      if (props.data?.reason?.includes("notObtain")) {
        setExplanation(props.data?.reason?.split("|")?.[1]);
      }
    }
  }, [haveTin, props, selected]);

  return (
    <>
      {country !== "SG" ? (
        <>
          <FieldLable>
            Select a country of your tax residence and TIN:
          </FieldLable>
          <>
            <Dropdown
              source={countryList.filter(
                (national) =>
                  !props.selectedCountry?.includes(national.id) &&
                  !excludeCountry.includes(national.id)
              )}
              placeholder="Select"
              bindLabel="label"
              bindId="id"
              name="nationality"
              onChange={(e) => {
                 trackOnFormStartOrSuccess("DS_tax_declaration_form")

                const nation = countryList.find(
                  (national) => national.id === e.target.value
                );
                setCountry(e.target.value);
                props.onUpdate("countryOfTaxResidence", e.target.value);
                props.onUpdate("countryOfTax", nation?.label);
              }}
              value={country}
              filteredList={props.selectedList}
            />
          </>
        </>
      ) : null}
      <TitleSm>
        Do you have a Tax Identification Number (TIN) ?
        <span className={tooltipSpan}>
          <Tooltip
            title="Tax Identification Number (TIN)"
            isIcon={true}
            inlineTextStyle={{
              color: EverGreenStyle.colors.primary,
              fontSize: EverGreenStyle.fontSize.description + "px",
              fontWeight: 600,
            }}
            isFixed
          >
            <span>
              For Singapore citizens and permanent residents, the TIN is your
              NRIC number. For foreigners who work or reside in Singapore, the
              TIN is your FIN (Foreign Identification Number).
            </span>
          </Tooltip>
        </span>
      </TitleSm>
      <ButtonContainer>
        <SelectButton
          selected={haveTin || false}
          onClick={() => {
            setHaveTin(false);
            trackOnFormStartOrSuccess("DS_tax_declaration_form")
            if (country === "SG") {
              props.onUpdate("hasSingaporeTaxNumber", "N");
              props.onUpdate("singaporeTaxNumber", "");
              props.onUpdate("reasonForNoTaxIdentificationNumber", selected);
            } else {
              props.onUpdate("hasOtherTaxNumber", "N");
              props.onUpdate("taxIdentificationNumber", "");
              props.onUpdate("reasonForNoTaxIdentificationNumber", selected);
            }
            if (selected?.includes("notObtain")) {
              props.onUpdate("reasonExplanation", explanation);
            }
          }}
        >
          No
        </SelectButton>
        <SelectButton
          selected={!haveTin}
          onClick={() => {
            trackOnFormStartOrSuccess("DS_tax_declaration_form")

            setHaveTin(true);
            if (country === "SG") {
              props.onUpdate("hasSingaporeTaxNumber", "Y");
              props.onUpdate("singaporeTaxNumber", tin);
              props.onUpdate("reasonForNoTaxIdentificationNumber", undefined);
              props.onUpdate("reasonExplanation", "");
            } else {
              props.onUpdate("hasOtherTaxNumber", "Y");
              props.onUpdate("taxIdentificationNumber", tin);
              props.onUpdate("reasonForNoTaxIdentificationNumber", undefined);
              props.onUpdate("reasonExplanation", "");
            }
          }}
        >
          Yes
        </SelectButton>
      </ButtonContainer>
      <div className={tinContentStyle}>
        {haveTin ? (
          <>
            <FieldLable>Tax Identification Number (TIN)</FieldLable>
            <Input
              onChange={(e) => {
            trackOnFormStartOrSuccess("DS_tax_declaration_form")

                setTin(e.target.value);
                if (country === "SG") {
                  props.onUpdate("singaporeTaxNumber", e.target.value);
                } else {
                  props.onUpdate("taxIdentificationNumber", e.target.value);
                }
              }}
              value={tin}
              margin={"13px 0 0 0"}
              boxLabel="Tax Identification Number"
              bgColor="transparent"
              color="black"
            />
          </>
        ) : (
          <>
            <TitleSm>Select a reason:</TitleSm>
            <div className={marketingRadioStyle}>
              <Checkbox
                type="radio"
                theme={EverGreenStyle}
                checked={selected === "notIssue"}
                newRedio={true}
                onChange={() => {
            trackOnFormStartOrSuccess("DS_tax_declaration_form")

                  setSelected("notIssue");
                  props.onUpdate(
                    "reasonForNoTaxIdentificationNumber",
                    "notIssue"
                  );
                  props.onUpdate("reasonExplanation", "");
                }}
              >
                <TextNormal>
                  The country does not issue TINs to its residents
                </TextNormal>
              </Checkbox>
            </div>
            <div className={marketingRadioStyle}>
              <Checkbox
                type="radio"
                theme={EverGreenStyle}
                checked={selected?.includes("notObtain")}
                newRedio={true}
                onChange={() => {
            trackOnFormStartOrSuccess("DS_tax_declaration_form")

                  setSelected("notObtain");
                  props.onUpdate(
                    "reasonForNoTaxIdentificationNumber",
                    "notObtain"
                  );
                }}
              >
                <TextNormal>
                  Unable to obtain TIN or equivalent number
                </TextNormal>
              </Checkbox>
            </div>
            {selected?.includes("notObtain") ? (
              <div className={explanationStyle}>
                <FieldLable>Provide more details below:</FieldLable>
                <TextArea
                  onChange={(e) => {
            trackOnFormStartOrSuccess("DS_tax_declaration_form")

                    setSelected(`notObtain | ${e.target.value}`);
                    setExplanation(e.target.value);
                    props.onUpdate(
                      "reasonForNoTaxIdentificationNumber",
                      `notObtain|${e.target.value}`
                    );
                    props.onUpdate("reasonExplanation", e.target.value);
                  }}
                  value={explanation}
                  color={EverGreenStyle.colors.primary}
                  maxLength={400}
                />
                <p className={lengthTextStyle}>{explanation?.length}/400</p>
              </div>
            ) : null}
            <div className={marketingRadioStyle}>
              <Checkbox
                type="radio"
                theme={EverGreenStyle}
                checked={selected === "notRequired"}
                newRedio={true}
                onChange={() => {
                  setSelected("notRequired");
            trackOnFormStartOrSuccess("DS_tax_declaration_form")

                  props.onUpdate(
                    "reasonForNoTaxIdentificationNumber",
                    "notRequired"
                  );
                  props.onUpdate("reasonExplanation", "");
                }}
              >
                <TextNormal>
                  TIN is not required
                  <br />
                  <span className={subTextStyle}>
                    To be selected only if the domestic law of the relevant
                    jurisdiction does not require the collection of the TIN
                    issued by such jurisdiction.
                  </span>
                </TextNormal>
              </Checkbox>
            </div>
          </>
        )}
      </div>
      {country !== "SG" ? (
        <div
          className={removeButtonStyle}
          onClick={() => {
            if (props.onRemove) props.onRemove();
          }}
        >
          <Icon name={"delete"} className={removeIconStyle} />
          Remove this Tax Residency
        </div>
      ) : null}
    </>
  );
}

function TaxDeclaration() {
  const dispatch = useAvivaDispatch();
  const tax = useAvivaSelector((state) => state.everGreenStep3.tax);
  const myInfo = useAvivaSelector((state) => state.everGreenStep2.myInfo);
  const [taxes, setTaxes] = useState(tax.otherTax || []);
  const occupation = useAvivaSelector(
    (state) => state.everGreenStep3.occupation.selectedOccupation
  );
  const countryList = useAvivaSelector(
    (state) => state.everGreenStep1.staticData.countryList
  );
  const history = useHistory();
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [openCRS, setOpenCRS] = useState<boolean>(false);
  const selectedCountry = useMemo(() => {
    return ["SG"];
  }, []);

  const dropdownList = useMemo(() => {
    let taxesList = [...taxes];
    let newcountryList = countryList.filter((tax) => {
      if (
        taxesList.find((x, i) => {
          if (x.countryOfTaxResidence === tax.id) {
            taxesList.splice(i, 1);
            return true;
          } else if (["SG", "US"].includes(tax.id)) {
            return true;
          }
          return false;
        })
      ) {
        return false;
      }
      return true;
    });
    return newcountryList;
  }, [taxes]);
  const addAnotherTax = () => {
    trackOnFormStartOrSuccess("DS_tax_declaration_form")
    setTaxes((prevTaxes) => {
      return [...(prevTaxes || []), initialTaxData];
    });
  };

  const onRemoveTax = useCallback(
    (index: number) => {
      trackOnFormStartOrSuccess("DS_tax_declaration_form")

      if (index === undefined) return;
      setErrors((previousError) => {
        const cloned = { ...previousError };
        delete cloned[index];
        return cloned;
      });
      setTaxes((previousTaxes) => {
        const cloned = [...previousTaxes];
        cloned.splice(index, 1);
        dispatch(updateTaxData({ otherTax: cloned }));
        return cloned;
      });
    },
    [dispatch]
  );

  const onUpdateSingaporeTax = useCallback(
    (fieldName: string, value: unknown) => {
      dispatch(updateTaxData({ [fieldName]: value }));

    },
    [dispatch]
  );

  const onUpdateOtherTax = useCallback(
    (fieldName: string, value: unknown, index?: number) => {
      if (index === undefined) return;
      setTaxes((previousTaxes) => {
        const cloned = [...previousTaxes];
        const otherTax = JSON.parse(
          JSON.stringify(cloned[index] || initialTaxData)
        );
        otherTax[fieldName] = value;
        cloned[index] = otherTax;
        dispatch(updateTaxData({ otherTax: cloned }));
        return cloned;
      });
    },
    [dispatch]
  );

  const validateAndContinue = useCallback(() => {
    if (tax.hasSingaporeTaxNumber === "N") {
      if (tax.otherTax.every((tax) => tax.hasOtherTaxNumber === "N")) {
        setOpenCRS(true);
        return;
      }
    }
    if (
      myInfo?.address?.country === "SINGAPORE" ||
      myInfo?.address?.country === "SG"
    ) {
      if (tax?.hasSingaporeTaxNumber === "N") {
        setOpenCRS(true);
        return;
      }
      if (
        !(
          !myInfo?.mailingAddress ||
          myInfo?.mailingAddress?.country === "SG" ||
          myInfo?.mailingAddress?.country === "SINGAPORE"
        )
      ) {
        const countryTax = taxes?.find(
          (tax) => tax.countryOfTaxResidence === myInfo?.mailingAddress?.country
        );
        if (!countryTax || countryTax.hasOtherTaxNumber === "N") {
          setOpenCRS(true);
          return;
        }
      }
    }
    trackOnFormStartOrSuccess("DS_tax_declaration_form", true)
    history.push(ROUTE_PATH.EVER_GREEN_PEP);
  }, [
    history,
    myInfo?.address?.country,
    myInfo?.mailingAddress,
    tax.hasSingaporeTaxNumber,
    tax.otherTax,
    taxes,
  ]);

  useEffect(()=>{
  if (occupation.id === "") return;
    trackOnLoad()
  },[])

  // Check if occupation step is completed or not
  if (occupation.id === "") {
    history.push(ROUTE_PATH.EVER_GREEN_OCCUPATION);
    return <></>;
  }

  return (
    <div className={`${containerBLock} scrollBlock`}>
      <MainContainer step={3} backButtonPath={ROUTE_PATH.EVER_GREEN_OCCUPATION}>
        <div>
          <Title align="center" variant="title">
            Declare your tax residency
          </Title>
          <div className={title14} style={{ marginTop: "16px" }}>
            <Title variant="description" align="center">
              Ensure that the information you provide us is accurate and up to
              date.
            </Title>
          </div>
        </div>
        <DropdownCard
          className={cardStyle}
          opacityValue="unset"
          title="Singapore Tax Residency Declaration"
          expanded
        >
          <div className={contentStyle}>
            <TaxContent
              onUpdate={onUpdateSingaporeTax}
              selectedList={dropdownList}
              data={{
                country: "SG",
                haveTin: tax.hasSingaporeTaxNumber !== "N" ? true : false,
                tinNumber: tax.singaporeTaxNumber,
                reason: tax.reasonForNoTaxIdentificationNumber || "notIssue",
              }}
              onError={(e) =>
                setErrors((previousError) => {
                  return {
                    ...previousError,
                    SG: e,
                  };
                })
              }
            ></TaxContent>
          </div>
        </DropdownCard>
        {taxes?.map((tax, index) => {
          return (
            <DropdownCard
              key={tax.countryOfTaxResidence || index}
              className={cardStyle}
              opacityValue="unset"
              title={`${
                countryList.find(
                  (national) => national.id === tax.countryOfTaxResidence
                )?.label || "New"
              } Tax Residency Declaration`}
              expanded
            >
              <div className={contentStyle}>
                <TaxContent
                  data={{
                    country: tax.countryOfTaxResidence,
                    haveTin: tax.hasOtherTaxNumber === "Y",
                    tinNumber: tax.taxIdentificationNumber,
                    reason:
                      tax.reasonForNoTaxIdentificationNumber || "notIssue",
                  }}
                  selectedList={dropdownList}
                  onRemove={() => onRemoveTax(index)}
                  selectedCountry={selectedCountry}
                  onUpdate={(field, value) => {
                    onUpdateOtherTax(field, value, index);
                  }}
                  onError={(e) =>
                    setErrors((previousError) => {
                      return {
                        ...previousError,
                        [index]: e,
                      };
                    })
                  }
                ></TaxContent>
              </div>
            </DropdownCard>
          );
        })}
        <ButtonContainer>
          <AddAnotherStyle
            disabled={taxes?.length === 3}
            onClick={() => addAnotherTax()}
          >
            <span className={addIconStyle}>+</span>
            Add another tax residency
          </AddAnotherStyle>
        </ButtonContainer>
        <ButtonContainer>
          <LooksGoodStyle
            className="nextBtn"
            disabled={!Object.values(errors).every((e) => !e)}
            onClick={validateAndContinue}
          >
            Next
          </LooksGoodStyle>
        </ButtonContainer>
      </MainContainer>
      <CRSModal show={openCRS} onCloseFn={() => setOpenCRS(false)} />
    </div>
  );
}

export default TaxDeclaration;
